import React from 'react';

import { steps } from './constants';

export const WhatHappensNext: React.FC = () => {
  return (
    <div className="mt-3 border-t border-[var(--line)] pt-6">
      <p className="mb-4 text-[13px] font-semibold tracking-wide text-[var(--ink-2)]">What happens next</p>
      <div className="flex flex-col">
        {steps.map(({ title, description }, index) => (
          <div key={title} className="flex gap-3">
            <div className="flex flex-col items-center">
              <div className="z-10 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-brand-gold-50 text-xs font-bold text-brand-orange">
                {index + 1}
              </div>
              {index < steps.length - 1 && <div className="w-px flex-1 bg-[var(--line)]" />}
            </div>
            <div className={`-mt-0.5 ${index < steps.length - 1 ? 'pb-4' : ''}`}>
              <p className="text-[13px] font-medium text-[var(--ink)]">{title}</p>
              <p className="mt-0.5 text-xs leading-relaxed text-[var(--ink-2)]">{description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
